import { hyphenateHTML } from 'hyphen/de';

const hyphen = () => {
  Array.from(
    document.querySelectorAll(
      '.c-card--transparent .c-card__headline,.c-single-map__headline,.c-sortable__title',
    ),
  ).forEach(el => {
    hyphenateHTML(el.innerHTML, { debug: false, minWordLength: 5 }).then(
      result => {
        // eslint-disable-next-line no-param-reassign
        el.innerHTML = result;
      },
    );
  });
};

hyphen();
